import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';


export default function MinorLesionRemoval() {
    const { t } = useTranslation();

    const accodirons = [
        {
            title: 'What it is?',
            content: 'Precision removal of small benign lesions such as skin tags and raised moles using laser or cautery.'
        },
        {
            title: 'How it works',
            content: 'Focused energy vaporizes the lesion while sparing surrounding skin. This allows clean removal with little to no bleeding.'
        },
        {
            title: 'Benefits',
            content: 'Clearer skin with minimal disruption and a low risk of visible scarring compared to surgical excision.'
        },
        {
            title: 'Areas',
            content: 'Anywhere you have a bothersome mole or tag. Common areas include the face, neck, underarms, chest, and neckline.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'Can be added to a facial visit. Many clients choose removal first, then finish with a brightening or nourishing facial for an even, polished result.'
        },
        {
            title: 'Downtime details',
            content: 'A tiny red spot or small scab is expected for about one to two weeks while the area heals. Aftercare includes keeping the area clean, protected, and out of the sun.'
        },
        {
            title: 'When to expect results',
            content: 'Once healed, the treated site gradually blends in with the surrounding skin.'
        },
    ]

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '10 to 30 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Mild'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'Social, up to 24 to 48 hours'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '1 to 3'
        }
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    data={{
                        type: "Skin Therapies",
                        title: "Minor Lesion Removal",
                        description: "Flawless skin, no unwelcome surprises. We offer quick removal of minor skin blemishes such as small moles, skin tags, or other benign lesions using advanced laser technology.",
                        book: "",
                        learn: ""
                    }}
                />
            </Box>

            <Box marginTop={{md: '83px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>


            <Box>
                <Box marginTop={{md: '56px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <Typography variant="body1" marginBottom={'74px'} className='dColor' textAlign={'center'} fontSize={'1.125rem'} fontWeight={'600'}>Key Information</Typography>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box display={'flex'} flexDirection={'column'} marginX={'auto'} gap={'20px'} marginTop={{ md: '128px', xs: '50px' }} className="generalContainer">
                <Typography variant="body1" className='dColor' fontWeight={'600'} fontSize={'1.125rem'} textAlign={'center'}>What Involves</Typography>
                <Typography variant="body1" className='dColor' fontWeight={'600'} fontSize={{ md: '30px', xs: '1.5rem' }} textAlign={'center'}>First, we assess the lesion to confirm it appears benign and is appropriate for in-clinic removal. A topical numbing cream or local anesthetic is applied for comfort. A focused beam is then used to precisely ablate the unwanted tissue. The energy essentially vaporizes the lesion with minimal impact on surrounding skin, resulting in little to no bleeding and a low risk of visible scarring compared to traditional excision.</Typography>
            </Box>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '95px', xs: '50px' }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            // book: '/',
                            type: 'Technology',
                            // learn: '/',
                            title: 'HIFES™',
                            size: { md: 8, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            // imageUrl: "/images/Mask_Group_42.png",
                            // flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: 'RF gently heats the dermis to stimulate collagen and elastin production, improving skin firmness and elasticity. At the same time, HIFES™ delivers high-intensity electromagnetic stimulation to facial elevator muscles, increasing tone and lift. In just a 20-minute session, RF firms the skin while HIFES™ enhances muscle support in the forehead, cheeks, and jawline.'
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>


            <Grid container gap={{md: '80px', xs: '30px'}} className="generalContainer" sx={{ marginX: 'auto', marginTop: {md: '80px', xs: '50px'} }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid container className='generalContainer' marginX={'auto'} gap={{md: '20px'}} marginTop={{md: '115px', xs: '50px'}} marginBottom={{md: '275px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontSize={{ md: '1.125rem', xs: '1rem' }} fontWeight={'bold'}>Treatment Areas</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                        Anywhere you have a bothersome mole or tag common areas include the face, neck, underarms, and chest. (For example, that tag on the neckline catching on your necklace, or a raised mole you dislike on your cheek can be seamlessly removed.) Post-Treatment: You’ll have a tiny red spot or scab for a week or two as it heals over. We provide aftercare like antibiotic ointment and sun protection guidance to aid healing.
                    </Typography>
                </Grid>
            </Grid>

           
        </Box>
    )
}